import { render, staticRenderFns } from "./SingleProgPage.vue?vue&type=template&id=29b3a6b8&"
import script from "./SingleProgPage.vue?vue&type=script&lang=js&"
export * from "./SingleProgPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports